import { call, put, takeLatest } from 'redux-saga/effects';
import Axios from '../../utils/Axios';
import { USER_CHANGE_PASSWORD_REQUEST, USER_CHANGE_PASSWORD_SUCCESS, USER_CHANGE_PASSWORD_FAILURE } from '../Actions/Actions';

function* changePasswordSaga(action) {
  try {
    const token = localStorage.getItem("authToken");
    console.log("Change password saga called", action.payload);
    const response = yield call(Axios.post,
      "/auth/change_password",
      {
        current_password: action.payload.current,
        new_password: action.payload.new,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("API response:", response.data);
    yield put({ type: USER_CHANGE_PASSWORD_SUCCESS, payload: response.data.message || "Success" });
  } catch (error) {
    console.log("API error:", error);
    yield put({ type: USER_CHANGE_PASSWORD_FAILURE, payload: error.response?.data?.message || "Error" });
  }
}

export function* watchChangePassword() {
  yield takeLatest(USER_CHANGE_PASSWORD_REQUEST, changePasswordSaga);
}